module.exports = __webpack_public_path__ + "img/logo.7a4d46e8.png";